module.exports = __webpack_public_path__ + "img/cn_pocket-13.9fa85d1.jpg";